import { CheckInOutHandler } from "@/components/Attendance/CheckInOutHandler";
import { DATE_FORMATS } from "@/constants";
import { cn } from "@/libs/cn";
import { Modal, Tag, Typography } from "antd";
import dayjs from "dayjs";
import { useEffect } from "react";

const AUTO_CLOSE_DURATION = 7 * 1000; // in ms

export function UserDataModal({
	meditatorData,
	opened,
	closeModal,
	isInAttendanceComp,
}: {
	meditatorData: MeditatorWithMeditationRetreat;
	opened: boolean;
	closeModal: () => void;
	isInAttendanceComp: boolean;
}) {
	const user = meditatorData?.user;
	const retreat =
		meditatorData?.events && meditatorData?.events.length > 0
			? meditatorData.events[0]
			: null;

	const userRegisteredMeditationRetreat = retreat
		? `${retreat.level.name} - ${retreat?.title} (${dayjs(
				retreat.fromDate,
			).format(DATE_FORMATS.DEFAULT_DISPLAY_DATE)} - ${dayjs(
				retreat.toDate,
			).format(DATE_FORMATS.DEFAULT_DISPLAY_DATE)})`
		: null;

	useEffect(() => {
		if (isInAttendanceComp && meditatorData) {
			const timerId = setTimeout(() => {
				closeModal();
			}, AUTO_CLOSE_DURATION);

			return () => clearTimeout(timerId);
		}
	}, [closeModal, isInAttendanceComp, meditatorData]);

	return (
		<Modal
			open={true}
			onCancel={closeModal}
			footer={null}
			width={isInAttendanceComp ? "100vw" : "70vw"}
			style={{
				top: 0,
				margin: 0,
				paddingBottom: 0,
				maxWidth: "100vw",
				height: isInAttendanceComp ? "100vh" : "680px",
			}}
			centered={!isInAttendanceComp}
			classNames={{
				content: cn(
					"!p-1 !rounded-none bg-primary-gradient overflow-hidden h-[680px] !rounded-md",
					{
						"h-screen !rounded-none": isInAttendanceComp,
					},
				),
				body: "!p-0 !overflow-hidden h-full rounded-sm",
			}}
			maskClosable={false}
			closable={!isInAttendanceComp}
		>
			<div className={cn("grid grid-cols-2 !overflow-hidden h-full")}>
				<img
					src={user?.profileUrl || "/assets/nfc_modal_backdrop.png"}
					className={cn(
						"h-full w-full bg-primary-gradient brightness-90 border-r border-gray-50",
						{
							"object-cover object-center": user?.profileUrl,
							"max-h-screen h-full": isInAttendanceComp,
						},
					)}
					alt="User Profile"
				/>

				<div className="relative z-10 p-8 space-y-5 bg-gradient-to-b self-stretch flex flex-col bg-white">
					<div className="space-y-4">
						<h2 className="text-4xl font-semibold">{user?.name}</h2>
						<div className="!space-x-2">
							<Tag color="var(--color-success)">
								{user?.level?.name}
							</Tag>
							<Tag color="var(--color-f80)">
								{user?.book?.bookNo || "N/A"}
							</Tag>
						</div>
					</div>

					<DataItem title="Note" value={user?.note || null} />
					<DataItem
						title="Meditation Event"
						value={userRegisteredMeditationRetreat}
					/>
					{!isInAttendanceComp && (
						<>
							<DataItem
								title="Phone Number"
								value={user?.phone || null}
								copyable={true}
							/>
							<DataItem title="NRC Number" value={user?.nrcNo} />
						</>
					)}
					{isInAttendanceComp && (
						<div className="mt-auto!">
							<br />
							<CheckInOutHandler
								userId={user?.id}
								closeModal={closeModal}
							/>
						</div>
					)}
				</div>
			</div>
		</Modal>
	);
}

const DataItem = ({
	title,
	value,
	copyable,
}: {
	title: string;
	value: string | null;
	copyable?: boolean;
}) => {
	return (
		<div className="space-y-1 font-poppins z-10">
			{/* <h2 className="font-semibold border-b-2 inline-block border-f80 text-2C/80">
				{title}
			</h2> */}
			<h2 className="font-semibold">{title}</h2>
			<p className="border border-f80 px-5 py-3 rounded-md text-base bg-gray-100">
				<Typography.Text className="font-poppins!" copyable={copyable}>
					{value ? value : "-"}
				</Typography.Text>
			</p>
		</div>
	);
};
